import { Button } from '@newcore/ui/buttons';
import { cn } from '@newcore/ui/cn';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Sizes } from '@newcore/ui/enums/sizes';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import { LogoVertical } from '@/components/logos';

interface SskSigningScreenProps {
  message: string;
  redirecting: boolean;
  error: { message: string; onRetry: () => void } | null;
}

export function SskSigningScreen({
  message,
  redirecting,
  error,
}: SskSigningScreenProps) {
  if (error) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <div className='flex flex-col items-center gap-6 text-center max-w-sm'>
          <LogoVertical />
          <Text
            as='h1'
            data-testid='ssk-signing-error'
            size={TextSizes.LG}
            weight={FontWeights.MEDIUM}
            className='text-error-primary'
          >
            Signing Failed
          </Text>
          <Text as='p' size={TextSizes.SM} className='text-secondary'>
            {error.message}
          </Text>
          <Button type='button' size={Sizes.MD} onClick={error.onRetry}>
            Try Again
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className='min-h-screen flex items-center justify-center'>
      <div className='flex flex-col items-center gap-6'>
        <LogoVertical />
        <div className='w-[200px] h-[3px] bg-secondary rounded-sm overflow-hidden'>
          <div
            className={cn(
              'h-full bg-[var(--color-text-primary)] rounded-sm',
              redirecting ? 'animate-progress-fill' : 'animate-progress-pulse'
            )}
          />
        </div>
        <Text as='p' size={TextSizes.LG} className='text-secondary'>
          {message}
        </Text>
      </div>
    </div>
  );
}
